// Waits for the background package save (MYS-7568). Never reports "failed" while the save may
// still finish on the server:
//   { outcome: 'done', result }    — saved
//   { outcome: 'error', error }    — the save failed (e.g. package travel SKU already in use)
//   { outcome: 'unknown' }         — the job stopped reporting (pod restart) or can no longer be
//                                    found: the save may or may not have been applied
//   { outcome: 'timeout' }         — still running at the cap; the save keeps running server-side
// A failed poll (network blip, 502/504 during a rollout) does not end the wait.
export async function pollPackageSaveJob({
	getStatus,
	intervalMs,
	capMs,
	onPollError = () => {},
	sleep = ms => new Promise(resolve => setTimeout(resolve, ms)),
	now = () => Date.now(),
}) {
	const startedAt = now()
	while (now() - startedAt < capMs) {
		await sleep(intervalMs)
		let status
		try {
			status = await getStatus()
		}
		catch (error) {
			if (error?.code === 404) return { outcome: 'unknown' }
			onPollError(error)
			continue
		}
		if (status?.status === 'DONE') return { outcome: 'done', result: status.result }
		if (status?.status === 'ERROR') return { outcome: 'error', error: status.error }
		if (status?.status === 'UNKNOWN') return { outcome: 'unknown' }
	}
	return { outcome: 'timeout' }
}
